import BaseRoute from 'seshy/routes/base';
import { service } from '@ember/service';

export default class TeamsIndexRoute extends BaseRoute {}
